/**
 * Apps Script web apps sometimes respond with an HTML error/redirect page
 * instead of JSON. Parse as text, retry, and surface clearer errors.
 */
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function fetchDeliveryJson(url, options = {}, config = {}) {
  // Attempts, not extra tries: at least one request is always made.
  const retries = Math.max(1, config.retries != null ? config.retries : 3);
  const retryDelayMs = config.retryDelayMs != null ? config.retryDelayMs : 1000;
  let lastError = null;

  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const resp = await fetch(url, options);
      const text = await resp.text();
      const trimmed = text.trim();
      if (!trimmed || trimmed.charAt(0) === '<') {
        lastError = new Error(
          'The delivery service returned a temporary Google error page. Please try again.'
        );
        if (attempt < retries - 1) await sleep(retryDelayMs);
        continue;
      }
      try {
        return JSON.parse(text);
      } catch (parseErr) {
        lastError = parseErr;
        if (attempt < retries - 1) await sleep(retryDelayMs);
        continue;
      }
    } catch (networkErr) {
      lastError = networkErr;
      if (attempt < retries - 1) await sleep(retryDelayMs);
    }
  }

  throw lastError || new Error('The delivery service did not respond.');
}

export function isLikelyFetchDropError(err) {
  if (!err) return false;
  const msg = String(err.message || err).toLowerCase();
  return (
    msg === 'failed to fetch' ||
    msg.includes('networkerror') ||
    msg.includes('load failed') ||
    msg.includes('network request failed')
  );
}
